import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/(root)/page.tsx");
